import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminPrescriptionsPage } from './admin-prescriptions';
import { DirectivesModule } from '../../directives/directives.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {TranslateModule} from "@ngx-translate/core";
import {TooltipsModule} from "ionic-tooltips";

@NgModule({
  declarations: [
    AdminPrescriptionsPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminPrescriptionsPage),
    DirectivesModule,
    NgxDatatableModule,
    TranslateModule,
    TooltipsModule
  ],
})
export class AdminPrescriptionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-prescriptions/admin-prescriptions.module.ts